<ng-container *transloco="let t; read: 'LOGS_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>
      <div class="right">
        <ion-button (click)="openStoreModal()" fill="none" color="secondary">
          <ion-icon slot="icon-only" name="storefront-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
  <ion-content class="ion-padding">
    <ion-button color="danger" fill="outline" (click)="clearLogs()">Clear all</ion-button>
    <div class="log flex flex-column" *ngFor="let log of logs$ | async">
      <div class="header flex flex-row">
        <div class="is-new mr-8" *ngIf="log.isNew"></div>
        <div class="date">{{ log.entryDate | translocoDate: { timeStyle: 'medium' } }}</div>
        <div class="level ml-4" [class.danger-color]="log.logLevel === LogLevel.Error" [class.warning-color]="log.logLevel === LogLevel.Warn">
          [{{ log.logLevel }}]
        </div>
        <div class="spacer"></div>
        <div class="date">{{ log.entryDate | translocoDate: { dateStyle: 'short' } }}</div>
      </div>

      <div class="message flex-row items-center">
        <div>[{{ log.scope }}] {{ log.message }}</div>
      </div>

      <div class="details">
        <pre *ngFor="let info of log.extraInfo">{{ info | json }}</pre>
      </div>
    </div>
  </ion-content>
</ng-container>
